import React, { FC } from 'react';
import { CircularProgress, Typography, Box } from '@mui/material';
import { LoadingOverlayWrapper } from './styles';

export interface LoadingOverlayProps {
  isLoading: boolean;
}

export const LoadingOverlay: FC<LoadingOverlayProps> = ({ isLoading }) => {
  return (<>
    {isLoading &&
      <LoadingOverlayWrapper>
        <Box sx={{ margin: 'auto', display: 'flex', flexDirection: 'column' }}>
          <CircularProgress size={50} sx={{ margin: 'auto' }} />
          <Typography sx={{ margin: '20px auto', fontSize: '1.4rem' }}>Please wait...</Typography>
        </Box>
      </LoadingOverlayWrapper>
    }
  </>)
};
